import { intersection, intersectionBy } from "lodash";
import type { StreamingContent, StreamingProvider } from "src/lib/movieinfo/movieinfotypes";

export interface IStreamingReleasesFilterState {
	showFilter: boolean;
	selectedGenres: IStreamingGenre[];
	selectedProviders: StreamingProvider[];
}

export interface IStreamingGenre {
	id: number;
	name: string;
	shortName?: string;
}



export const STREAMING_GENRES: IStreamingGenre[] = [
	{
		"id": 12,
		"name": "Eventyr"
	},
	{
		"id": 14,
		"name": "Fantasy"
	},
	{
		"id": 16,
		"name": "Animasjon"
	},
	{
		"id": 18,
		"name": "Drama"
	},
	{
		"id": 27,
		"name": "Skrekk"
	},
	{
		"id": 28,
		"name": "Action"
	},
	{
		"id": 35,
		"name": "Komedie"
	},
	{
		"id": 36,
		"name": "Historie"
	},
	{
		"id": 37,
		"name": "Western"
	},
	{
		"id": 53,
		"name": "Thriller"
	},
	{
		"id": 80,
		"name": "Krim"
	},
	{
		"id": 99,
		"name": "Dokumentar"
	},
	{
		"id": 878,
		"name": "Science fiction"
	},
	{
		"id": 9648,
		"name": "Mystikk"
	},
	{
		"id": 10402,
		"name": "Musikk"
	},
	{
		"id": 10749,
		"name": "Romantikk"
	},
	{
		"id": 10751,
		"name": "Familie"
	},
	{
		"id": 10762,
		"name": "Barneserier"
	},
	{
		"id": 10763,
		"name": "Nyhetsserier"
	},
	{
		"id": 10764,
		"name": "Realityserier"
	},
	{
		"id": 10766,
		"name": "Såpeserier"
	},
	{
		"id": 10767,
		"name": "Talkshow"
	},
	{
		"id": 10768,
		"name": "Krig og politikk"
	},
	{
		"id": 10770,
		"name": "TV-filmer",
		"shortName": "tvf"
	}
];

export const INTIAL_STATE: IStreamingReleasesFilterState = {
	showFilter: false,
	selectedGenres: [],
	selectedProviders: []

}

export type ShowActionType = {
	type: "show";
};

type HideActionType = {
	type: "hide";
};

type ApplyFilterActionType = {
	type: "applyFilter";
	selectedProviders: StreamingProvider[];
	selectedGenres: IStreamingGenre[];
};

type PreInitFilterActionType = {
	type: "preinitfilter";
	providers: StreamingProvider[];
	genres: IStreamingGenre[];
};

export type ActionType = ShowActionType | HideActionType | ApplyFilterActionType | PreInitFilterActionType;

export function filterReducer(state: IStreamingReleasesFilterState, action: ActionType): IStreamingReleasesFilterState {
	switch (action.type) {
		case "show":
			return { ...state, showFilter: true };
		case "hide":
			return { ...state, showFilter: false };
		case "preinitfilter":
			return { ...state, selectedGenres: action.genres, selectedProviders: action.providers };
		case "applyFilter":
			const _action = action as ApplyFilterActionType;

			return {
				...state,
				selectedProviders: [..._action.selectedProviders],
				selectedGenres: [..._action.selectedGenres],
				showFilter: false
			};
		default:
			return state;
	}
}

/**
 * Whether a release matches the selected filter: at least one of the selected genres (if any)
 * and at least one of the selected providers (if any). No selection matches everything.
 */
export function matchesFilter(release: StreamingContent, { selectedGenres, selectedProviders }: Pick<IStreamingReleasesFilterState, "selectedGenres" | "selectedProviders">): boolean {
	if (selectedGenres.length > 0 && intersection(selectedGenres.map(g => g.name), release.genres ?? []).length === 0) {
		return false;
	}
	if (selectedProviders.length > 0) {
		const providers = release.providerContents?.map(pc => pc?.provider) ?? [];
		return intersectionBy(selectedProviders, providers, p => p?.id).length > 0;
	}
	return true;
}
